// extracted by mini-css-extract-plugin
export default {"textField":"Text_textField__BsgPZ","itemTitle":"Text_itemTitle__qeT61","itemValue":"Text_itemValue__VBCIf","audItem":"Text_audItem__IKnQU","audName":"Text_audName__Rh+o4"};